import { ModalActions, ModalBody, ModalHeroImage } from '@strava/ui/Modal';
import React, { useEffect } from 'react';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import welcomeImage from './images/welcome.jpg';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';

import styles from './Welcome.scss';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import { displayName } from '../../../../../../utils/general-utils';
import { REGISTRATION_FLOW } from '../../../../shared/onboardingConstants';

const Welcome = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { firstName } = state.currentAthlete;

  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });

  useEffect(() => {
    track({
      page: analyticsPageName(REGISTRATION_FLOW.welcome),
      action: 'screen_enter'
    });
  }, [track]);

  return (
    <>
      <ModalHeroImage src={welcomeImage} alt="" />
      <ModalBody>
        <h2 data-cy="welcome">
          {t('welcome.title', { name: displayName({ firstName }) })}
        </h2>
        <p>{t('welcome.subtitle')}</p>
      </ModalBody>

      <ModalActions className={styles.modalActions}>
        <ActionButton
          variant="primary"
          onClick={() => stepForward(ACTIONS.getStarted)}
          data-cy="welcome-next-step-btn"
          disabled={isProcessing}
        >
          {t('welcome.get_started')}
        </ActionButton>
      </ModalActions>
    </>
  );
};

export default Welcome;
